/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Student_BadgeInputs */

const en_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Popular`)
};

const de_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beliebtester Plan`)
};

const fr_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le plus populaire`)
};

const es_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más popular`)
};

const it_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più popolare`)
};

const nl_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meest Populair`)
};

const pl_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpopularniejszy`)
};

const fi_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suosituin`)
};

const da_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest populær`)
};

const sv_settings_student_badge = /** @type {(inputs: Settings_Student_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest Populär`)
};

/**
* | output |
* | --- |
* | "Most Popular" |
*
* @param {Settings_Student_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_student_badge = /** @type {((inputs?: Settings_Student_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Student_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_student_badge(inputs)
	if (locale === "fr") return fr_settings_student_badge(inputs)
	if (locale === "es") return es_settings_student_badge(inputs)
	if (locale === "it") return it_settings_student_badge(inputs)
	if (locale === "nl") return nl_settings_student_badge(inputs)
	if (locale === "pl") return pl_settings_student_badge(inputs)
	if (locale === "fi") return fi_settings_student_badge(inputs)
	if (locale === "da") return da_settings_student_badge(inputs)
	if (locale === "sv") return sv_settings_student_badge(inputs)
	return en_settings_student_badge(inputs)
});